import React from 'react'
import TruncateMarkup from 'react-truncate-markup'
import clsx from 'clsx'

import OverflowText from '../../../atoms/OverflowText'

import { useBreakpoint } from '../../../../providers/BreakpointProvider'
import { useUserAPI } from '../../../../providers/UserAPIProvider'
import useBaseStyles from '../styles'

const GetAssignedName = ({ baseClasses, assignedUser, user, isSmall }) => {
  if (user && assignedUser && assignedUser.name === user.name) {
    const content = (
      <span>
        <span className={baseClasses.bold}>{user.name}</span> assigned the
        conversation to themselves
      </span>
    )
    return isSmall ? (
      <OverflowText className={baseClasses.mobileLine}>{content}</OverflowText>
    ) : (
      <OverflowText className={baseClasses.line}>{content}</OverflowText>
    )
  }

  const content = (
    <span>
      Conversation assigned to
      <span className={baseClasses.bold}>
        {assignedUser?.name ?? 'unknown'}
      </span>
      {user && (
        <span>
          {' '}
          by <span className={baseClasses.bold}>{user.name}</span>
        </span>
      )}
    </span>
  )
  return isSmall ? (
    <OverflowText className={baseClasses.mobileLine}>{content}</OverflowText>
  ) : (
    <OverflowText className={baseClasses.line}>{content}</OverflowText>
  )
}

const Assigned = ({ user, meta, date }) => {
  const { isSmall } = useBreakpoint()
  const { allUsers, loadUser } = useUserAPI()

  const baseClasses = useBaseStyles()

  const assignedTo = React.useMemo(() => meta?.assigned_to, [meta])
  const assignedUser = React.useMemo(
    () => (assignedTo ? allUsers[assignedTo] : null),
    [assignedTo, allUsers]
  )

  React.useEffect(() => {
    if (assignedTo) {
      loadUser(assignedTo)
    }
  }, [assignedTo, loadUser])

  if (isSmall) {
    return (
      <div>
        <div
          className={clsx(baseClasses.message, baseClasses.additionalMargin)}
        >
          <GetAssignedName
            baseClasses={baseClasses}
            user={user}
            assignedUser={assignedUser}
            isSmall={isSmall}
          />
        </div>
        <div>
          <label className={baseClasses.message}>{date}</label>
        </div>
      </div>
    )
  }

  return (
    <TruncateMarkup lines={2}>
      <div className={clsx(baseClasses.message, baseClasses.additionalMargin)}>
        <TruncateMarkup.Atom>
          <GetAssignedName
            baseClasses={baseClasses}
            user={user}
            assignedUser={assignedUser}
            isSmall={isSmall}
          />
        </TruncateMarkup.Atom>

        <div style={{ marginLeft: '0.25rem' }}>{date}</div>
      </div>
    </TruncateMarkup>
  )
}

export default Assigned
